import React from 'react';

import { Button, Flexbox, FontAwesomeIcon, Toggle, Tooltip } from '@schoolinks/ui-components';

import { bool, func, string } from 'prop-types';

import { useTranslation } from 'react-i18next';

import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';

const WalletVisibilitySwitch = ({
  isCredentialWalletPublic,
  updateStudentProfile,
  publicLinkTooltip,
  copyToClipboard,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Flexbox alignItems="center" columnGap={0.5}>
        <Toggle
          checked={isCredentialWalletPublic}
          label={t('CredentialWallet.WalletVisibilitySwitch.SetAsPublic')}
          labelDirection="right"
          onChange={(_, checked) => {
            updateStudentProfile({
              payload: {
                isCredentialWalletPublic: checked,
              },
            });
          }}
          value={isCredentialWalletPublic}
        />

        <Tooltip placement="left" title={publicLinkTooltip}>
          <div>
            <FontAwesomeIcon color="grayDark" icon={faInfoCircle} />
          </div>
        </Tooltip>
      </Flexbox>
      <Button
        color='default'
        disabled={!isCredentialWalletPublic}
        hasIconLeft
        icon={<FontAwesomeIcon icon={faLink} />}
        label={t('CredentialWallet.WalletVisibilitySwitch.CopyLink')}
        onClick={copyToClipboard}
        size="small"
        variant="filled"
      />
    </>
  );
};

WalletVisibilitySwitch.propTypes = {
  isCredentialWalletPublic: bool.isRequired,
  updateStudentProfile: func.isRequired,
  publicLinkTooltip: string.isRequired,
  copyToClipboard: func.isRequired,
};

export default WalletVisibilitySwitch;
